import {songPathUrl} from '../../../shared/services/songPathUtils';

export const isSongbook = path => typeof path === 'string' && path.toLowerCase().endsWith('.txt');
export const fileTitle = path => path.split('/').pop().replace(/\.txt$/i, '');
export const fileDirectory = path => path.split('/').slice(0, -1).join('/');
export const catalogUrl = songPathUrl;

export const fileActivity = (fileName, opened, modifiedTime) => {
  const valid = value => value && Number.isFinite(new Date(value).getTime());
  if (valid(opened?.dateTime)) return {...opened, fileName, kind: 'opened'};
  if (valid(modifiedTime)) return {fileName, dateTime: modifiedTime, kind: 'modified'};
  return null;
};

export const buildCatalog = paths => {
  const root = {name: '', path: '', folders: [], files: [], allFiles: []};
  paths.filter(isSongbook).forEach(path => {
    const parts = path.split('/');
    const file = parts.pop();
    let node = root;
    node.allFiles.push(path);
    parts.forEach(part => {
      let child = node.folders.find(folder => folder.name === part);
      if (!child) {
        child = {name: part, path: node.path ? `${node.path}/${part}` : part, folders: [], files: [], allFiles: []};
        node.folders.push(child);
      }
      child.allFiles.push(path);
      node = child;
    });
    node.files.push({name: file, path});
  });
  const sort = node => {
    node.folders.sort((a, b) => a.name.localeCompare(b.name, 'pl', {numeric: true, sensitivity: 'base'}));
    node.files.sort((a, b) => a.name.localeCompare(b.name, 'pl', {numeric: true, sensitivity: 'base'}));
    node.folders.forEach(sort);
  };
  sort(root);
  return root;
};

export const findCatalog = (root, path) => path
  ? path.split('/').reduce((node, part) => node?.folders.find(folder => folder.name === part), root)
  : root;
